/**
 * Новая сборка на сервере: при смене экрана — перезагрузка, на месте — плашка.
 *
 * Перезагружаем ТОЛЬКО на переходе на другой путь: адрес уже новый, ничего
 * введённого на прежнем экране не осталось. Смена параметров на том же экране
 * (правило, город) не перезагружает — там бывает ввод; вместо этого плашка
 * «обновить», и человек жмёт её сам. Проверка — раз в 5 минут и на каждом
 * переходе (`lib/freshBuild.ts`).
 */
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";

import { serverHasNewBuild } from "@/lib/freshBuild";

const ПРОВЕРКА_МС = 5 * 60_000;

export function FreshBuild() {
  const { pathname } = useLocation();
  const [новая, setНовая] = useState(false);
  const прежний = useRef(pathname);

  useEffect(() => {
    const сменилсяЭкран = прежний.current !== pathname;
    прежний.current = pathname;
    if (сменилсяЭкран && новая) {
      window.location.reload();
      return;
    }
    let жив = true;
    void serverHasNewBuild().then((got) => {
      if (жив && got) setНовая(true);
    });
    return () => {
      жив = false;
    };
  }, [pathname, новая]);

  useEffect(() => {
    const таймер = window.setInterval(() => {
      void serverHasNewBuild().then((got) => got && setНовая(true));
    }, ПРОВЕРКА_МС);
    return () => window.clearInterval(таймер);
  }, []);

  if (!новая) return null;
  return (
    <button
      type="button"
      onClick={() => window.location.reload()}
      // Внизу ПО ЦЕНТРУ: правый нижний угол занят кнопкой «разметка».
      className="fixed bottom-4 left-1/2 z-50 -translate-x-1/2 rounded-[var(--radius-card)] border border-accent bg-bg px-3 py-2 text-[12.5px] text-accent-text shadow-lg hover:bg-bg-hover"
      data-annot="новая версия"
    >
      вышла новая версия — обновить
    </button>
  );
}
